import { MessageCircle } from "lucide-react";
import { fcfa } from "@/lib/api";

const orderText = (o) => [
  `Bonjour ${o.shop_name}, je viens de passer la commande ${o.number} sur Casadeal :`,
  ...o.items.map((i) => `- ${i.quantity} × ${i.title}${i.variant ? ` (${i.variant})` : ""} : ${fcfa(i.line_total, o.currency)}`),
  `Livraison${o.delivery_zone ? ` (${o.delivery_zone.name})` : ""} : ${fcfa(o.delivery_fee, o.currency)}`,
  `Total : ${fcfa(o.total, o.currency)} (paiement à la livraison)`,
  `Nom : ${o.delivery.name} · Tél : ${o.delivery.phone}`,
  `Adresse : ${o.delivery.address}, ${o.delivery.city}`,
].join("\n");

export const WhatsAppOrderButton = ({ o }) => {
  if (!o.shop_whatsapp) {
    return <p data-testid="order-whatsapp-missing" className="text-sm text-gray-500">Ce vendeur n'a pas encore indiqué de numéro WhatsApp. Utilisez la messagerie ci-dessous pour le contacter.</p>;
  }
  const href = `https://wa.me/${o.shop_whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(orderText(o))}`;
  return (
    <div className="space-y-2">
      <a href={href} target="_blank" rel="noopener noreferrer" data-testid="order-whatsapp-btn"
        className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-bold text-white transition-opacity hover:opacity-90">
        <MessageCircle className="h-4 w-4" />Prévenir le vendeur sur WhatsApp
      </a>
      <p className="text-xs text-gray-500">Ce bouton ouvre WhatsApp avec un message déjà rédigé pour {o.shop_name}. Rien n'est envoyé automatiquement : appuyez sur « Envoyer » dans WhatsApp.</p>
    </div>
  );
};
